import { Flex, Typography, theme } from 'antd';
import { TableCellEcho, type Column } from '@/components/TableEcho';
import { PlatformSelectionTableEcho } from '@/routes/AudiencePage/charts/PlatformSelectionTableEcho';
import type { AgeData, AgePlaysResponse, SelectedPlatform } from '@/types/api/age';
import { formatPercentage } from '@/utils/numberFormattingUtils';
import { sortByPlatformDisplayOrder } from '@/utils/platformUtils';

export const AgeDataByPlatformEcho = ({
  data,
  selectedPlatform,
  handlePlatformChange,
}: {
  data: AgePlaysResponse;
  selectedPlatform: SelectedPlatform<typeof data>;
  handlePlatformChange: (platform: SelectedPlatform<typeof data>) => void;
}) => {
  const { token } = theme.useToken();

  const getHighestValueLabel = (ageDistribution: AgeData[]) => {
    const highestValueAgeGroup = [...ageDistribution].sort(
      (firstAgeGroup, secondAgeGroup) => secondAgeGroup.value - firstAgeGroup.value
    )[0];

    return (
      <Flex align="center" gap={token.marginXXS}>
        <Typography.Text>{highestValueAgeGroup.label}</Typography.Text>
        <Typography.Text
          style={{
            color: token.colorTextSecondary,
            fontSize: token.fontSizeSM,
            fontWeight: 300,
          }}
        >
          {formatPercentage(highestValueAgeGroup.percentage)}%
        </Typography.Text>
      </Flex>
    );
  };

  const tableColumns: Column[] = [
    { key: 'radio', header: '', align: 'left' },
    { key: 'platform', header: 'Platform', align: 'left', className: 'px-2' },
    { key: 'top_age_group', header: 'Top age group', align: 'left', className: 'px-2' },
    { key: 'median_age', header: 'Median age', align: 'right', className: 'px-2' },
  ];

  return (
    <Flex style={{ maxWidth: '100%' }}>
      <PlatformSelectionTableEcho<AgePlaysResponse, AgePlaysResponse['plays'][number]>
        idPrefix="age-data"
        data={sortByPlatformDisplayOrder(data)}
        selectedPlatform={selectedPlatform}
        handlePlatformChange={handlePlatformChange}
        tableColumns={tableColumns}
        renderDataCells={(rowData) => (
          <>
            <TableCellEcho align="left" className="px-2">
              {getHighestValueLabel(rowData.age_distribution)}
            </TableCellEcho>
            <TableCellEcho align="right" className="px-2">
              {rowData.median_age}
            </TableCellEcho>
          </>
        )}
      />
    </Flex>
  );
};
